import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/queue_monitor_templates/queue_monitor.template.htm';
import TemplateTwo from 'text-loader!../templates/queue_monitor_templates/queue_monitor_two.template.html';
import TemplateMultiple from 'text-loader!../templates/queue_monitor_templates/queue_monitor_multiple.template.html';
import Collection from '../models/monitors.paginated.collection.ts';
import Pagination from '../views/pagination.view.ts';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import 'dhtmlxMessage';
import i18n  from 'l10n';
import popup from 'popup';

import '../../libs/jquery-dynamicFontSize/jquery-dynamicFontSize.js';

export default Backbone.View.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	templateTwo: Handlebars.compile(TemplateTwo),
	templateMultiple: Handlebars.compile(TemplateMultiple),
	interval: null,
    collection: null,
    wsocket: null,
    autoRefreshTimer: null,
    intervalTimes: {
        "el": 7000,
        "en": 7000
    },
	initialize: function (options) {
		var self = this;
		this.queueIds = options.queueIds;

		$(window).off("popstate").on("popstate", function() {
		    if(self.autoRefreshTimer)
		        clearInterval(self.autoRefreshTimer);
		    self.clearListener();
		});

        this.collection = new Collection();
        this.collection.url = 'rest/monitors/multiQueues?ids='+ encodeURIComponent(self.queueIds);
        this.collection.on( 'sync', this.successMonitorsData, this );
        this.collection.on( 'error', this.errorMonitorsData, this );

        this.setupAudio();

        this.collection.getFirstPage();

        if(this.autoRefreshTimer)
            clearInterval(this.autoRefreshTimer);


        /*this.hasJustShownAd = false;
        this.shouldShowAd = false; //toDo: to be used in a future version -- ad
        this.hasToggledLanguage = true;*/

        this.startAutoRefreshTimer();

        this.clearListener();
        this.setListener();
	},
	setupAudio: function() {
        var self = this;

        // get the dom element, so we can have access on its functions
        this.beepAudio = $("#beep-audio")[0];

        // volume between 0.0-1.0 (1 is the default value)
        $(this.beepAudio).prop("volume", 1);

        this.beepAudio.addEventListener("ended", function(){
             self.beepAudio.currentTime = 0;
        });

        $(this.beepAudio).find(".audio-ogg").attr("src", "/sounds/beep.ogg");
        $(this.beepAudio).find(".audio-wav").attr("src", "/sounds/beep.wav");
        $(this.beepAudio).find(".audio-mp3").attr("src", "/sounds/beep.mp3");

        // load the sounds
        this.beepAudio.load();

    },
	startAutoRefreshTimer: function() {
        var self = this;

        var intervalTime = this.intervalTimes[i18n.lng()];
        // re-call the `checkLangAndGetNextPage` function, after the `intervalTime` value
        this.autoRefreshTimer = setTimeout(function() {
            // for interval times, check the `this.intervalTimes` object
            self.checkLangAndGetNextPage();
        }, intervalTime);
    },
    checkLangAndGetNextPage: function() {
        var self = this;

        var isLastPage = this.collection.state.currentPage == this.collection.state.lastPage; // isLastPage can be in two occasions: 1) only one page, 2) last page of the iteration
        var hasNextPage = this.collection.state.currentPage < this.collection.state.lastPage;
        // show an ad each time all the pages are iterated in both languages
        /*if(isLastPage && !self.shouldShowAd && !self.hasToggledLanguage) {
            self.shouldShowAd = true
        } else {
            self.shouldShowAd = false;
            if(!hasNextPage)
                self.toggleLanguage();
        }
        //toDo: to be used in a future version
        if (!hasNextPage || (hasNextPage && self.hasJustShownAd)) {
            self.collection.getFirstPage();
        } else {
            self.collection.getNextPage();
        }*/

        if (!hasNextPage) {
            this.toggleLanguage();
            this.collection.getFirstPage();
        } else {
            this.collection.getNextPage();
        }

        this.startAutoRefreshTimer();
    },
	toggleLanguage: function() {
	    var lang = i18n.lng();
        lang = lang == "el" ? "en" : "el";
        i18n.setLng(lang);

        //this.hasToggledLanguage = !this.hasToggledLanguage; //toDo: to be used in a future version -- ad
	},
	successMonitorsData: function()
	{
        var self = this;
	    this.isMultipleMonitor = self.collection.models.length > 2 || self.queueIds.length > 2;
        this.render();
        this.refreshUI();
        this.refreshPaginationUI();

        this.pagination = new Pagination({ collection : this.collection });
        this.pagination.render();
        this.cc = this.cc ? this.cc + 1 : 1;
	},
    errorMonitorsData: function(response)
	{

	},
	refreshUI: function(stompData)
	{
	    var temp;
	    if(stompData)
	        temp = stompData;
	    else
	        temp = this.collection.models;

		if(!this.isRenderCallAgain)
		{
			this.render();
		}
		this.refreshAVGWaitingTime(temp);
		this.refreshPendingTicket(temp);
		this.refreshServingTicket(temp);
		this.refreshNextTicket(temp);
        this.refreshCounter(temp);

	},
	refreshNextTicket: function(models)
	{
        for (var i=0; i<models.length; i++)
        {
            var nextTicketElement =  $("#queue-"+models[i].attributes.queue.id).find(".monitor-next-ticket");
            var nextTicket = models[i].attributes.nextTicket;
            if(!nextTicket)
            {
                nextTicketElement.html("-");
                continue;
            }

            var nextTicketPhone = models[i].attributes.nextCustomerCode;
            //var prompt = nextTicket + " ("+nextTicketPhone+")"; todo: removed
            var prompt = nextTicket.substr(1);

            nextTicketElement.html(prompt);
        }

	},
	refreshPaginationUI: function()
	{
	     var currentPage = this.collection.state.currentPage + 1;
	     var lastPage = this.collection.state.lastPage + 1;

	     if(this.collection.totalPages <= 1)
	        $(".pagination").html('');
	     else
	        $(".pagination").html(currentPage+"/"+lastPage);
	},
	refreshAVGWaitingTime: function(models)
	{
        for (var i=0; i<models.length; i++)
        {

            var avgElement = $("#queue-"+models[i].attributes.queue.id);


            var appendQuote = "'";

            if(!models[i].attributes.queueStatistics)
            {
                avgElement.find(".monitor-avg-waiting").html("0"+appendQuote);
            } else {
                var avg = models[i].attributes.queueStatistics.averageWaitTime;
                avg = ""+avg;
                avg = avg.split(".");

                avgElement.find(".monitor-avg-waiting").html(avg[0]+appendQuote);
            }

        }
	},
	refreshServingTicket: function(models)
	{
        for (var i=0; i<models.length; i++)
        {

            var queueElement = $("#queue-"+models[i].attributes.queue.id);
            if(!models[i].attributes.queue || !models[i].attributes.queue.currentTicketNumber  || models[i].attributes.queue.currentTicketNumber == 0)
            {
                if(!this.isMultipleMonitor)
                {
                    queueElement.find(".monitor-customer-code").text("-");
                }
                queueElement.find(".monitor-current-ticket").text("-");

            } else if( $("#queue-"+models[i].attributes.queue.id).find(".monitor-current-ticket").text() != models[i].attributes.queue.currentTicketNumber) {
                var currentCustomerCode = models[i].attributes.customerCode;
                var currentTicket = this.getAppropriateTicketNumber(models[i].attributes);
                //var currentTicket = models[i].attributes.currentTicketDisplayNumber; //toDO: use it in a future version

                var ticketPrompt = currentTicket  +" ("+ currentCustomerCode +")";

                if(!this.isMultipleMonitor)
                {
                    ticketPrompt = currentTicket;
                    //queueElement.find(".monitor-customer-code").text("("+currentCustomerCode+")"); //todo: removed
                }

                queueElement.find(".monitor-current-ticket").text(ticketPrompt);


                if(!this.isMultipleMonitor)
                    this.calculateAndSetTicketContainerWidth(queueElement.find(".monitor-current-ticket"));
            }
        }

	},
	calculateAndSetTicketContainerWidth: function(elemRef) {
	    elemRef.dynamicFontSize({
	        maximumFontSize: 200,
	        minimumFontSize: 82,
	        horizontalAlign: "center",
	        horizontalAlignMargin: false, //use margin to horizontal alignment
	        verticalAlign: "middle",
	        wordBreak: null,
	        error: 5 //accepted error, in percentage value {0-100}
	    });
	},
	getAppropriateTicketNumber: function(attr) {
	    return attr.queue.currentTicketNumber;

	    /*if(attr.isPriorityTicket == true) //todo: removed
            return "A" + attr.queue.currentTicketNumber;
        return "B" + attr.queue.currentTicketNumber;*/
	},
	refreshCounter: function(models)
	{
        for (var i=0; i<models.length; i++)
        {
            var counterName = "-";
            var counterElement =  $("#queue-"+models[i].attributes.queue.id).find(".monitor-counter");
            if(models[i].attributes.counters )
            {
                for(var j = 0; j < models[i].attributes.counters.length; j++)
                {
                    var counterTemp = models[i].attributes.counters[j];
                    if( models[i].attributes.queue.currentTicketNumber == counterTemp.currentServicingTicketNumber)
                    {
                        counterName = counterTemp.counter.name;
                        break;
                    }

                }

            }

            var appendArrow = "";
            if (!this.isMultipleMonitor && counterName != "-")
                appendArrow = "<i class='fa fa-caret-right'></i>";


            counterElement.html(appendArrow+counterName);
        }

	},
	refreshPendingTicket: function(models)
    {
        for (var i=0; i<models.length; i++)
        {
            var queueElement =  $("#queue-"+models[i].attributes.queue.id);

            if(!models[i].attributes.queueStatistics)
            {
               queueElement.find(".monitor-pending-tickets").html("0");
            } else {
               queueElement.find(".monitor-pending-tickets").html(models[i].attributes.queueStatistics.pendingCount);
            }

        }
    },
	superRender: Backbone.View.prototype.render,
	render: function () {
        var self = this;
		this.superRender();
		this.isRenderCallAgain = true;

        // we show 'ad' either when we have no models to show
        /*if(this.collection.models.length == 0) {
            if( this.$el.find(".monitor-container").length == 0 &&
                this.$el.find(".no-open-queues-container").length == 0) { // template not loaded yet
                this.loadDefaultTemplate();
            }

            //return;
        }
        //toDo: to be used in a future version -- ad
        // we show an ad, after each time we reach the last page of the collection (but only after we have already toggled language)
        if(this.shouldShowAd) {
            if( this.$el.find(".monitor-container").length == 0 ) // template not loaded yet
                this.loadDefaultTemplate();

            this.renderAd(); // hide data and show Ad
            this.hasJustShownAd = true;

            return;
        }

        this.hasJustShownAd = false;*/

        if(this.collection.models.length == 0) {
            this.loadDefaultTemplate();
            return;
        }

        if (this.queueIds.length == 1)
            this.$el.html(this.template( { collection: this.collection.models[0] } ));
        else if (this.queueIds.length == 2)
            if(this.collection.models.length == 2)
                this.$el.html(this.templateTwo( { collection: this.collection.models  } ));
            else
                this.$el.html(this.template( { collection: this.collection.models[0] } ));
        else
            this.$el.html(this.templateMultiple( { collection: this.collection.models } ));

        /*this.$el.find(".monitor-container").show(); //toDo: to be used in a future version -- ad
        this.$el.find(".monitor-ad-container").hide();*/
	},
	/*renderAd: function() {
        this.$el.find(".monitor-container").hide(); //toDo: to be used in a future version -- ad
        this.$el.find(".monitor-ad-container").show();
    },*/
    loadDefaultTemplate: function() {
        // either all selected queues our closed, or none was found
        var self = this;
        var defaultParam = { collection: null };

        if (this.queueIds.length == 1)
            this.$el.html(this.template(defaultParam));
        else if (this.queueIds.length == 2)
            this.$el.html(this.templateTwo(defaultParam));
        else
            this.$el.html(this.templateMultiple(defaultParam));
    },
	setListener: function()
	{
		var self = this;
        this.clearListener();

		this.wsocket = new SockJS('rest/live');
		this.client = Stomp.over(this.wsocket);

		var headers = {
			origin: 'https://q-edis.com',
		};

		this.client.connect(headers, function(frame) {
            self.client.subscribe('/live/monitors/queues/multi', function (message){
		        var jsonResponse;

                try {
                    jsonResponse = JSON.parse(message.body);

                    if(jsonResponse && jsonResponse.action == "nextCalled") {

                        var queueThatNextWasCalled = $.grep(self.collection.models, function(model, index) {
                            return model.attributes.queue.id === jsonResponse.queue.id;
                        });

                        // if queue is in the currently displayed list, play the sound
                        if(queueThatNextWasCalled && queueThatNextWasCalled.length == 1) {

                            var $currentTicketContainer = $("#queue-" + jsonResponse.queue.id).find(".monitor-current-ticket");

                            if(!$currentTicketContainer.hasClass('with-animation'))
                                $currentTicketContainer.addClass('with-animation');
                            else {
                                $currentTicketContainer.removeClass('with-animation');

                                setTimeout(function() {
                                    $currentTicketContainer.addClass('with-animation')
                                }, 10);
                            }

                            // if not Paused and has currentTime (meaning the timer of it has started), then it is playing
                            var isPlaying = !self.beepAudio.paused || (self.beepAudio.currentTime != null && self.beepAudio.currentTime > 0);

                            if(!isPlaying) {
                                self.beepAudio.play();
                            }
                        }

                    } else {
                        self.refreshUI(self.parseResponse(JSON.parse(message.body)));
                    }

                }catch(er) {
                    console.error("Error while parsing json ", er)
                }
		    });

		    self.client.subscribe('/live/monitors/reload/', function (){
                location.reload();
            });
		});
	},
	parseResponse: function(response)
	{
        var queueIds = $.map(this.collection.models, function(value, index){
            return value.attributes.queue.id;
        });

        var data = []; //response.data.collection
        data.push(response);

        data = $.grep(data, function(x){
            return queueIds.includes(x.queue.id);
        });

        var objColl = [];
        for (var i=0; i<data.length; i++)
        {
            var obj = {
                queue: data[i].queue,
                queueStatistics: data[i].queueStatistics,
                nextTicket: data[i].nextTicketNumber,
                counters: data[i].countersInfo,
                nextCustomerCode: data[i].nextCustomerCode,
                currentPhone: data[i].currentTicketPhone,
                customerCode: data[i].customerCode,
                isPriorityTicket: data[i].isPriorityTicket,
                //currentTicketDisplayNumber: data[i].currentTicketDisplayNumber  //toDO: use it in a future version
            };
            objColl.push({attributes: obj} );
        }
        return objColl;

	},
	clearListener: function()
	{
	    if(!this.client)
	        return;

		this.client.disconnect(function() {
		    console.log(i18n.t("queue.client_disconnected"));
		});
	},
	clearView: function()
	{
		this.clearListener();
	},
	events:{
	}
});

